import DashboardComponent from '@/components/dashboard.vue';

const routes = [
    { path: '/dashboards/:id', component: DashboardComponent, props: true } //
];

export { routes };

export default routes;
